import {useState} from "react";
import axios from "axios";

import {UseFormSubmitOptions} from "@/constants/type/props";


export function useFormSubmit({contactType, onSuccess, reset}: UseFormSubmitOptions) {
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (formData: any) => {
    const payload = {
      contactType,
      ...formData,
    };

    try {
      setErrorMessage("");
      const res = await axios.post(`${import.meta.env.PUBLIC_ENV__API_URL}/contact-us`, payload);
      console.log(res);

      if (res.data.success) {
        reset();
        onSuccess?.();
      }
    } catch (error) {
      console.log(error);
      setErrorMessage("There was an error sending your message. Please try again.");
    }
  };

  return {
    errorMessage,
    handleSubmit,
  };
}
